import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from '@mui/material';
import { MdSportsCricket } from '@teamworksdev/icons';
import { trpc } from '../../../../trpc/react';

export function CricketOrgSeedCommand({ orgId }: { orgId: string | null }) {
  const seedMutation = trpc.admin.developerTools.seedCricketOrg.useMutation();

  return (
    <Paper className="p-6">
      <Typography variant="h2" className="mb-2">
        Seed Cricket Org
      </Typography>
      <Typography variant="body2" className="mb-4">
        Creates the Bowling exercise, Delivery Type metric, and Bowling workout
        template for the selected org. Safe to re-run — it's a no-op if these
        already exist.
      </Typography>
      <Box className="flex flex-col gap-4">
        <Box>
          <Button
            variant="contained"
            onClick={() => orgId && seedMutation.mutate({ orgId })}
            disabled={!orgId || seedMutation.isLoading}
            startIcon={
              seedMutation.isLoading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <MdSportsCricket />
              )
            }
          >
            {seedMutation.isLoading ? 'Running...' : 'Run'}
          </Button>
        </Box>

        {seedMutation.isSuccess && (
          <Alert severity="success">
            Cricket org entities seeded successfully.
          </Alert>
        )}

        {seedMutation.isError && (
          <Alert severity="error">
            Failed to seed cricket org entities: {seedMutation.error.message}
          </Alert>
        )}
      </Box>
    </Paper>
  );
}
